/**
 * "AI operations" nav icon — the Gap Report entry.
 *
 * Exported from the Kim AI Figma file (node I4848:8803;1707:403, layer `AI operations`): a panel
 * outline plus the four-point sparkle. The export's #1F2126 fills and strokes are swapped for
 * `currentColor` so the glyph dims with the rest of the nav item when inactive, the way
 * `AiAgentsIcon` does.
 */
export function AiOperationsIcon({ className }: { className?: string }) {
	return (
		<svg
			/*
			 * Two deliberate changes from the 18x18 export, both to make this read as one of the
			 * lucide icons it sits between in the sidebar (see `ai-agents-icon.tsx` for the same
			 * lesson learned the hard way).
			 *
			 * 1. strokeWidth 1.5, not the export's 1.0125. Lucide draws 2-in-24; at an 18 viewBox
			 *    that is 1.5. The export's hairline read visibly lighter than House and Database.
			 * 2. viewBox shifted +0.75 on x. With a 1.5 stroke the ink spans x 2.25–17.25 and
			 *    y 1.5–16.5 — 15 of 18 units, which is lucide's own 20-of-24 ink ratio, so at the
			 *    sidebar's `[&>svg]:size-5` it renders the same 16.7px. But the sparkle pushes the
			 *    ink right of centre, so the box is moved with it; the height already centres.
			 */
			viewBox='0.75 0 18 18'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
			aria-hidden='true'
		>
			<path
				d='M9 15.75V4.5C9 4.30109 8.92098 4.11032 8.78033 3.96967C8.63968 3.82902 8.44891 3.75 8.25 3.75H4.5C4.10218 3.75 3.72064 3.90804 3.43934 4.18934C3.15804 4.47064 3 4.85218 3 5.25V14.25C3 14.6478 3.15804 15.0294 3.43934 15.3107C3.72064 15.592 4.10218 15.75 4.5 15.75H13.5C13.8978 15.75 14.2794 15.592 14.5607 15.3107C14.842 15.0294 15 14.6478 15 14.25V10.5C15 10.3011 14.921 10.1103 14.7803 9.96967C14.6397 9.82902 14.4489 9.75 14.25 9.75H3'
				stroke='currentColor'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M14.706 2.19601C15.0097 3.12431 15.6257 3.74031 16.554 4.04402C17.482 4.34801 17.482 4.65199 16.554 4.95598C15.6257 5.25969 15.0097 5.87569 14.706 6.80399C14.402 7.732 14.098 7.732 13.794 6.80399C13.4903 5.87569 12.8743 5.25969 11.946 4.95598C11.018 4.65199 11.018 4.34801 11.946 4.04402C12.8743 3.74031 13.4903 3.12431 13.794 2.19601C14.098 1.268 14.402 1.268 14.706 2.19601Z'
				fill='currentColor'
			/>
		</svg>
	);
}
